<div class="page-wrapper">
  <a
    class="back-arrow-inner"
    style="cursor: pointer"
    (click)="navigateBackToMemberSearch()"
    ><mat-icon matListIcon>arrow_back</mat-icon> Member Search</a
  >
  <!-- Page Header -->
  <div class="page-header">
    <h2>Clinical Reviews</h2>
  </div>
  @if (selectedMemberDetails(); as selectedMemberDetails) {
    <!-- Member Detail card -->
    <div class="detail-card">
      <div class="client-id-name">
        <h4>Member</h4>
        <span
          >(Client: {{ selectedMemberDetails.clientId }}-{{
            selectedMemberDetails.client_full_name
          }})</span
        >
      </div>
      <div class="mat-row">
        <div class="mat-2">
          <label class="card-label">Name</label>
          <p>
            {{ selectedMemberDetails.firstName }}
            {{ selectedMemberDetails.lastName }}
          </p>
        </div>
        <div class="mat-2">
          <label class="card-label">Person Code</label>
          <p>{{ selectedMemberDetails.personCode }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">DOB</label>
          <p>{{ selectedMemberDetails.DOB | timeStampToDate }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">Relationship</label>
          <p>
            {{ selectedMemberDetails.relationshipCode }} -
            {{ relationShip[selectedMemberDetails.relationshipCode] }}
          </p>
        </div>
        <div class="mat-2">
          <label class="card-label">Card/Alt ID</label>
          <p>{{ selectedMemberDetails.cardId }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">Coverage Type</label>
          <p>
            {{
              displayCoverageType[selectedMemberDetails?.coverage?.coverageType]
            }}
          </p>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    @if (showTable()) {
      @if (showBannerMessage()) {
        <div class="note-wrapper">
          <p>
            **Determination letters are mailed to members and are not available
            in the portal. Direct members to Member Services if they need a
            copy.
          </p>
        </div>
      }
      <div class="filter-block mb-4 mt-4 ng-star-inserted">
        <div class="mat-10">
          <!-- <h4 class="result-found-data">{{ totalLength() }} Results Found</h4> -->
        </div>
        <div class="search-input-block">
          <img src="../../../../assets/images/search-icon.svg" alt="" />
          <input
            type="text"
            class="form-control"
            (keyup)="search($event)"
            placeholder="Search"
            #input
          />
        </div>
        <!-- FILTER FEATURE - Commented out as per requirements -->
        <!-- TODO: Uncomment the below code once the filter functionality is implemented -->
        <!--
        <button
          mat-button
          #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="menu"
          class="filter-icon"
        >
          <mat-icon matListIcon>filter_alt</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" class="filter-box">
          <div (click)="$event.stopPropagation()">
            <div class="slide-toggle-field">
              <div class="filter-heading">
                Filter by Year
                <mat-icon class="close-icon" matListIcon (click)="closeFilter()"
                  >close</mat-icon
                >
              </div>
              <menu class="filter-menu">
                <mat-form-field
                  floatLabel="never"
                  class="full-width mat-custom-select"
                >
                  <mat-select
                    placeholder="Select"
                    [formControl]="yearFilterControl"
                  >
                    @for (value of yearsFilterOptions; track value) {
                      <mat-option [value]="value">
                        {{ value }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </menu>
            </div>
            <div class="action-buttons">
              <button
                class="primary-btn"
                (click)="applyYearFilter()"
                mat-button
              >
                Apply
              </button>
            </div>
          </div>
        </mat-menu>
         -->
      </div>
    }
    @if (showTable()) {
      <div
        class="custom-box no-padding hidden custom-height prescriptions-table"
      >
        <table
          mat-table
          [dataSource]="dataSource()"
          matSort
          class="clinical-review-table"
        >
          <!-- Inquiry Id Column -->
          <ng-container matColumnDef="reviewId">
            <th
              class="header-center"
              scope="col"
              mat-header-cell
              *matHeaderCellDef
            >
              Clinical Review ID
            </th>
            <td mat-cell class="center" *matCellDef="let row">
              {{ row.authNumber }}
            </td>
          </ng-container>
          <!-- drugName Column -->
          <ng-container matColumnDef="drugName">
            <th scope="col" mat-header-cell *matHeaderCellDef>Drug Name</th>
            <td mat-cell *matCellDef="let row">{{ row.drug }}</td>
          </ng-container>
          <!-- memberName Column -->
          <ng-container matColumnDef="memberName">
            <th scope="col" mat-header-cell *matHeaderCellDef>Member Name</th>
            <td mat-cell *matCellDef="let row">
              {{ row.patient.firstName + " " + row.patient.lastName }}
            </td>
          </ng-container>
          <!-- createDate Column -->
          <ng-container matColumnDef="createDate">
            <th
              class="header-center"
              scope="col"
              mat-header-cell
              *matHeaderCellDef
            >
              Status Date
            </th>
            <td class="center" mat-cell *matCellDef="let row">
              @if (row.statusChangeDate || row.createdDate) {
                {{ getDisplayDate(row) | timeStampToDate }}
              }
            </td>
          </ng-container>
          <!-- status Column -->
          <ng-container matColumnDef="status">
            <th scope="col" mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              {{ row.status }}
            </td>
          </ng-container>
          <!-- statusDescription Column -->
          <ng-container matColumnDef="statusDescription">
            <th scope="col" mat-header-cell *matHeaderCellDef>
              Status Description
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.statusDescription }}
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="documentUrl">
            <th class="center" scope="col" mat-header-cell *matHeaderCellDef>
              Clinical Reviews
            </th>
            <td mat-cell *matCellDef="let row" class="center">
              @if (row?.documentUrl) {
                <span class="last-td-width">
                  <p class="text-primary mb-0 center">
                    <a
                      title="view"
                      (click)="
                        processFile(row?.documentUrl, row?.inquiryId, 'view')
                      "
                      class="mr-4 pointer"
                    >
                      <img
                        src="../../../../assets/images/file-view.svg"
                        alt=""
                      />
                    </a>

                    <a
                      title="download"
                      (click)="
                        processFile(
                          row?.documentUrl,
                          row?.inquiryId,
                          'download'
                        )
                      "
                      class="pointer"
                    >
                      <img
                        src="../../../../assets/images/file-download.svg"
                        alt=""
                      />
                    </a>
                  </p>
                </span>
              }
              @if (!row?.documentUrl) {
                <span class="center d-block dash">-</span>
              }
            </td>
          </ng-container> -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            (keydown.enter)="$event.stopPropagation()"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
          <!-- Row shown when there is no matching data. -->
          <ng-container *matNoDataRow>
            @if (totalLength() == 0 || dataSource().data.length === 0 || dataSource().filteredData.length === 0) {
              <tr class="mat-row mat-mdc-no-data-row">
                <td class="mat-cell" colspan="10" role="status">
                  No Data found
                </td>
              </tr>
            }
          </ng-container>
        </table>
        <div class="mt-2">
          <mat-paginator
            #paginator
            [pageSize]="limit()"
            [pageIndex]="currentPageIndex()"
            [pageSizeOptions]="[5, 10]"
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      </div>
    }
  }
</div>
